import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from '@emotion/css';
import { Icon, Spinner } from '@vp/swan';
const spinnerStyle = css `
    position: absolute;
`;
const deleteIcon = css `
    background-color: black;
    max-width: 26px;
    width: 28%;
    max-height: 26px;
    height: 28%;
    border-radius: 100%;
    justify-content: center;
    align-items: center;
`;
/**
 * Component to show a deleting spinner
 */
export const DrawerThumbnailDeleteIndicator = (props) => {
    const { title } = props;
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: spinnerStyle, "data-testid": "deleting-spinner" }, { children: _jsx(Spinner, { size: "super", accessibleText: "", role: "status" }) })), _jsx("div", Object.assign({ className: deleteIcon }, { children: _jsx(Icon, { iconType: "deleteStudio", skin: "white", title: title, margin: 0, size: "16p" }) }))] }));
};
DrawerThumbnailDeleteIndicator.displayName = 'DrawerThumbnailDeleteIndicator';
//# sourceMappingURL=DrawerThumbnailDeleteIndicator.js.map